<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      嶂背站<br>
站点介绍<br>
嶂背站位于龙岗区宝荷路南侧，车站主体沿山体呈南北走向布置，南接大运站，北接南约站。 嶂背站色彩基调以白色调为主，以“阳光+”缤纷生活为主题，在站台采用彩虹色作为装饰亮点，营造出一个“穿越彩虹的车站”趣味空间。车站为地下一层站台+地面厅半地下的侧式站台结构。车站设置有2个出入口，临近中国医学科学院肿瘤医院深圳医院、嶂背工业区，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:25	23:24	14号线	4分30秒	6分15秒<br>
沙田	06:31	00:01	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:24	23:24	14号线	5分25秒	6分15秒<br>
沙田	06:31	00:01	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:24	00:24	14号线	5分钟	6分15秒<br>
沙田	06:31	01:01	14号线	5分钟	6分15秒<br><br>

站点出口信息<br><br>
A出入口:<br>
嶂背路北侧、宝荷路南侧、深圳市肿瘤医院<br><br>
B出入口:<br>
嶂背路北侧、宝荷路南侧、深圳市肿瘤医院<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 肿瘤医院站<br>
M303、M304（龙东方向）、M306、M322、M357、M447、M458、N28、高峰专线193路、M304（爱联方向）<br><br>
A出入口:<br>
公交站名： 肿瘤医院站<br>
M303、M304（龙东方向）、M306、M322、M357、M447、M458、N28、高峰专线193路、M304（爱联方向）<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>